/*
 * 詳細画面パーツ
 * リスト表示
 */
<template>
<tr class="tr-td-control">
	<td class="td-dataname">
		<div><!-- 空白除けコメントアウト
			-->{{r_title}}
			<div v-if="edit_right && r_is_require" class="layout-right">
				<font class="text-red">＊</font>
			</div>
		</div>
	</td>
	<td v-if="edit_right" class="td-data">
		<el-form :model="m_ruleForm" :rules="m_validationCode" ref="valid_target">
			<el-form-item prop="code" class="text_code_area" >
				<c-selectitem 
					class="text-input" 
					:r_list="r_list"
					:r_select_class="createEditClassType(m_ruleForm.code)" 
					r_name_sub_class=""
					:r_not_match_list_text="r_not_match_list_text"
					:r_disabled="r_disabled"
					@input="onInputSelectValue"
					v-model="m_ruleForm.code" >
				</c-selectitem>
			</el-form-item>
		</el-form >
	</td>
	<td v-else class="td-data"><!-- 空白除けコメントアウト
	-->{{r_textdata}}
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * メモ.<br>
	 * @module js/parts_com/TR/editSelect
	 * @example
	 * <c-detailitemname
	 * 	:messages = "messages" 
	 * 	:settings = "settings" 
	 * 	:info="m_info" 
	 * 	@keyup="keyup" 
	 * >
	 * </c-detailitemname> 
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} r_info - 編集するデータ
	 **/
	 export default {
		mixins: [
			require('js/common/Edit.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/edit.mixin.vue'),
		],
		props:{
			'r_messages': {},
			'r_settings': {},
			'r_title': {
				type:String,
				default: ""
			},
			'r_list': {},
			'r_textdata':{},
			'r_select_class': {
				type:String,
				default: ""
			},
			'r_not_match_list_text': {
				type:String,
				default: ""
			},
			'value': {},
			'r_disabled': {
				type:Boolean,
				default:false
			},
			'r_isChange': {
				type:Boolean,
				default: true,
			},
			// ユーザーの編集権限をチェックするか
			'r_check_editable': {
				type:Boolean,
				default: true,
			},
		},
		data: function () {
			var target = this;
			return{
				m_ruleForm:{code:this.value},
				m_validationCode:{
					code: [
						{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' },
						{
							validator: (rule, value, callback) => {
								var errMessage = "";
								
								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}
							},
							trigger: ''
						}
					],
				}
			}
		},
		watch:{
			value: function(val){
				this.m_ruleForm.code = val;
			}
		},
		computed:{
			// 編集可能か
			edit_right:function() {
				if (!this.r_check_editable) {
					return true;
				}
				if (this.r_settings.edit_right) {
					return true;
				}
				return false;
			},
		},
		methods: {
			/**
			 * キーアップイベント <br>
			 * ******* 内部処理 *******<br>
			 * フラグを変更する。 <br>
			 *
			 * @function onKeyup
			 * @param {object} e - イベントオブジェクト
			 * @instance
			 */
			onKeyup: function( e ){
			 	this.$emit('keyup', e);
			},
			onFocus: function( e ){

			},
			onInputSelectValue: function( val ){
				this.m_isChange = this.r_isChange;
				this.$emit('input', val);
				this.$emit("event_change",val);
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * @prop {component} c-inputname - 文字入力
		 * @instance
		 **/
		components: {
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editSelectPullDown.vue